import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import fullTagList from '../assets/tags.json';
import { EMPTY_OBJECT } from '../constants';

const TAGS = keyBy(fullTagList, 'id');

export function getTag(id) {
  return TAGS[id];
}

export function getTagName(id) {
  const tag = getTag(id);

  if (tag.type === 'Camera') {
    if (['Framing', 'Movement'].includes(tag.group)) {
      return `${tag.name} ${tag.group.toLowerCase()}`;
    }
  }

  if (tag.type === 'Energy') {
    return `${tag.name} energy`;
  }

  return tag.name;
}

export function allTags() {
  return { ...TAGS };
}

export function groupTags(tags) {
  const types = {};

  tags.map(tag => {
    const typeContainer = types[tag.type] || {};
    const groupContainer = typeContainer[tag.group] || [];
    groupContainer.push(tag);
    groupContainer.sort(compareTags);
    typeContainer[tag.group] = groupContainer;
    types[tag.type] = typeContainer;
  });

  return types;
}

export function compareTags(a, b) {
  // Ordered tags sort by order.
  if (a.order !== undefined && b.order !== undefined) {
    return a.order - b.order;
  }

  // Other tags sort by name.
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }

  return 0;
}



// WEBPACK FOOTER //
// ./src/lib/tags.js